import React from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { InfoOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Tooltip } from '@lyearn/ui';
import SkillDetailsInTooltip from '@/modules/org-hierarchy/modules/org-roles/views/OrgRoleDetails/components/OrgRoleSkills/components/SkillMasteryConfigs/components/SkillDetailsInTooltip';

import { SkillTooltipProps } from './types';

const classes = { tooltip: 'p-0 w-[31.6rem] max-w-none' };

function SkillTooltip(props: SkillTooltipProps) {
  const { skill } = props;
  const [open, { on, off }] = useToggle(false);

  if (skill.description || skill.rubrics?.length) {
    return (
      <Tooltip
        classes={classes}
        enterDelay={0}
        placement="right"
        title={<SkillDetailsInTooltip skill={skill} />}
        variant="popover"
        onClose={off}
        onOpen={on}>
        <Box>
          <InfoOutline
            className={cn(
              'h-16 w-16 cursor-pointer',
              open ? 'text-icon-secondary' : 'text-icon-placeholder',
            )}
          />
        </Box>
      </Tooltip>
    );
  }

  return null;
}

export default SkillTooltip;
